module.exports = __webpack_public_path__ + "img/1.90dd2a54.png";